import { apiInstance } from './index.js';
const api = apiInstance();

export function fetchGet(url, param) {
    return api.get(url, param);
}

export function fetchPost(url, param) {
    return api.post(url, param)
}
  